import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MaterialModule } from '../material.module';
import { FlexLayoutModule } from '@angular/flex-layout';
import { RouterModule } from '@angular/router';
import { PortalModule } from '@angular/cdk/portal';

import { PillarModule } from '../pillar/pillar.module';
import { routes } from './routes.config';
import { ConfigurationDashboardComponent } from './components/configuration-dashboard.component';

@NgModule({
  entryComponents: [],
  declarations: [ConfigurationDashboardComponent],
  imports: [
    CommonModule,
    MaterialModule,
    FlexLayoutModule,
    RouterModule.forChild(routes),
    PortalModule,
    PillarModule
  ],
  exports: [],
  providers: []
})
export class ConfigurationModule {
}



// WEBPACK FOOTER //
// ./src/app/configuration/configuration.module.ts